import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { NotificationResModel } from 'src/app/models/notification.model';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { NegotiationService } from 'src/app/services/negotiation/negotiation.service';
@Injectable({
  providedIn: 'root'
})
export class NotificationResolverService implements Resolve<any> {

  constructor(private  negotiationService: NegotiationService,
    private commonService: CommonService,
    private sessionService: BrowserStorageService) { }

    resolve(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<Array<NotificationResModel>>|Promise<Array<NotificationResModel>>| Array<NotificationResModel> {
        return this.getAllNotification();
    }

  /**
   * Get Licence Data
   * @returns
   */
  getAllNotification(): Observable<Array<NotificationResModel>> {
    let negotiationResObj: any = [];
    if (!this.sessionService.getSessionData()) {
      return of(negotiationResObj);
    }
    
    return this.negotiationService.getAllNegotiationNotification('initial', true).pipe(map((notificationRes: any) => {
        // Support both new paginated response and legacy array response
        const notifications = notificationRes?.notifications || notificationRes;
        if (Array.isArray(notifications) && notifications.length > 0) {
          return notifications;
        } else {
          return negotiationResObj;
        }
    }),catchError((error) => {
      this.commonService.showToastError(error);
      return of(negotiationResObj);
    }) );
   
  }
}
